




























































































































import { Component, Watch } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import WindowVue from "@/app/core/window/WindowVue";
import GameObjectManager from "@/app/basic/GameObjectManager";
import ColorPickerComponent from "@/app/core/component/ColorPickerComponent.vue";
import UserSelect from "@/app/basic/common/components/select/UserSelect.vue";
import SocketFacade, {
  permissionCheck
} from "@/app/core/api/app-server/SocketFacade";
import { StoreUseData } from "@/@types/store";
import { ActorStore } from "@/@types/gameObject";
import SimpleTabComponent from "@/app/core/component/SimpleTabComponent.vue";
import { TabInfo, WindowOpenInfo } from "@/@types/window";
import TaskProcessor from "@/app/core/task/TaskProcessor";
import { Task, TaskResult } from "task";
import LanguageManager from "@/LanguageManager";
import ActorSelect from "@/app/basic/common/components/select/ActorSelect.vue";
import ChatColorTypeSelect from "@/app/basic/common/components/select/ChatColorTypeSelect.vue";
import PlayerBoxViewTypeRadio from "@/app/basic/common/components/radio/PlayerBoxViewTypeRadio.vue";
import RangeComponent from "@/app/basic/common/components/RangeComponent.vue";
import SButton from "@/app/basic/common/components/SButton.vue";
import VueEvent from "@/app/core/decorator/VueEvent";
import TaskManager from "@/app/core/task/TaskManager";
import { DataReference } from "@/@types/data";
import SCheck from "@/app/basic/common/components/SCheck.vue";
import TrCheckboxComponent from "@/app/basic/common/components/TrCheckboxComponent.vue";
import TrRangeComponent from "@/app/basic/common/components/TrRangeComponent.vue";
import TrColorPickerComponent from "@/app/basic/common/components/TrColorPickerComponent.vue";
import TrChatColorInputComponent from "@/app/basic/common/components/TrChatColorInputComponent.vue";
import BaseInput from "@/app/core/component/BaseInput.vue";
import TrActorStatusSelectComponent from "@/app/basic/common/components/TrActorStatusSelectComponent.vue";

@Component({
  components: {
    TrActorStatusSelectComponent,
    BaseInput,
    TrChatColorInputComponent,
    TrColorPickerComponent,
    TrRangeComponent,
    TrCheckboxComponent,
    SCheck,
    SButton,
    RangeComponent,
    PlayerBoxViewTypeRadio,
    ChatColorTypeSelect,
    ActorSelect,
    SimpleTabComponent,
    UserSelect,
    ColorPickerComponent
  }
})
export default class PlayerBoxWindow extends Mixins<WindowVue<string, never>>(
  WindowVue
) {
  private userList = GameObjectManager.instance.userList;
  private actorCC = SocketFacade.instance.actorCC();
  private actorList = GameObjectManager.instance.actorList;
  private userId: string = GameObjectManager.instance.mySelfUserId;
  private viewType: "actor" | "piece" = "actor";
  private searchText: string = "";

  @LifeCycle
  public async mounted() {
    await this.init();
  }

  @VueEvent
  private get ownerActorList(): StoreUseData<ActorStore>[] {
    return this.actorList.filter(a => {
      if (!permissionCheck(a, "view")) return false;

      if (this.searchText) {
        const name = a.data!.name;
        const regExp = new RegExp(this.searchText);
        if (!name.match(regExp)) return false;
      }
      return !(this.userId && a.owner !== this.userId);
    });
  }

  @VueEvent
  private get tabbedOwnerActorList(): StoreUseData<ActorStore>[] {
    return this.actorList.filter(a => {
      if (!permissionCheck(a, "view")) return false;

      if (this.searchText) {
        const name = a.data!.name;
        const regExp = new RegExp(this.searchText);
        if (!name.match(regExp)) return false;
      }
      if (
        this.currentActorTabInfo &&
        a.data!.tag !== this.currentActorTabInfo.target
      ) {
        return false;
      }
      return !(this.userId && a.owner !== this.userId);
    });
  }

  @VueEvent
  private getOwnerType(userId: string): string {
    const user = this.userList.filter(u => u.id === userId)[0];
    return this.$t(`label.${user.data!.type}`)!.toString();
  }

  @VueEvent
  private getOwnerName(userId: string): string {
    return GameObjectManager.instance.getUserName(userId);
  }

  private actorTabList: TabInfo[] = [
    { target: "actor", text: "" },
    { target: "piece", text: "" }
  ];
  private currentActorTabInfo: TabInfo | null = this.actorTabList[0];

  @TaskProcessor("language-change-finished")
  private async languageChangeFinished(
    task: Task<never, never>
  ): Promise<TaskResult<never> | void> {
    this.createActorTabInfoList();
    task.resolve();
  }

  @LifeCycle
  private async created() {
    this.createActorTabInfoList();
  }

  @Watch("ownerActorList", { deep: true })
  private createActorTabInfoList() {
    this.actorTabList = this.ownerActorList
      .map(a => a.data!.tag)
      .filter(
        (tag: string, idx: number, list: string[]) => list.indexOf(tag) === idx
      )
      .map(tag => ({
        target: tag,
        text: tag || this.$t("label.non-tag")!.toString()
      }));
    const idx = this.currentActorTabInfo
      ? this.actorTabList.findIndex(
          at =>
            at.text === this.currentActorTabInfo!.text &&
            at.target === this.currentActorTabInfo!.target
        )
      : -1;
    if (idx === -1) {
      this.currentActorTabInfo = this.actorTabList[0];
    }
  }

  @VueEvent
  private async addActor() {
    await TaskManager.instance.ignition<WindowOpenInfo<void>, never>({
      type: "window-open",
      owner: "Quoridorn",
      value: {
        type: "actor-add-window"
      }
    });
  }

  @VueEvent
  private isEditable(tabInfo: StoreUseData<ActorStore>) {
    return permissionCheck(tabInfo, "edit");
  }

  @VueEvent
  private async editActor(actor: StoreUseData<ActorStore>) {
    if (!this.isEditable(actor)) return;

    await TaskManager.instance.ignition<WindowOpenInfo<DataReference>, never>({
      type: "window-open",
      owner: "Quoridorn",
      value: {
        type: "actor-edit-window",
        args: {
          type: "actor",
          docId: actor.id!
        }
      }
    });
  }

  @VueEvent
  private isChmodAble(tabInfo: StoreUseData<ActorStore>) {
    return permissionCheck(tabInfo, "chmod");
  }

  @VueEvent
  private async chmodActor(actor: StoreUseData<ActorStore>) {
    if (!this.isChmodAble(actor)) return;

    await TaskManager.instance.ignition<WindowOpenInfo<DataReference>, never>({
      type: "window-open",
      owner: "Quoridorn",
      value: {
        type: "chmod-window",
        args: {
          type: "actor",
          docId: actor.id!
        }
      }
    });
  }

  @VueEvent
  private isDeletable(tabInfo: StoreUseData<ActorStore>) {
    return permissionCheck(tabInfo, "edit");
  }

  @VueEvent
  private async deleteActor(actor: StoreUseData<ActorStore>) {
    if (!this.isDeletable(actor)) return;
    const msg = PlayerBoxWindow.getDialogMessage("delete-actor").replace(
      "$1",
      actor.data!.name
    );
    const result = window.confirm(msg);
    if (!result) return;

    try {
      await this.actorCC.touchModify([actor.id!]);
    } catch (err) {
      // TODO error message.
      return;
    }
    await this.actorCC.delete([actor.id!]);
  }

  private static getDialogMessage(target: string) {
    const msgTarget = "player-box-window.dialog." + target;
    return LanguageManager.instance.getText(msgTarget);
  }

  @VueEvent
  private onHover(messageType: string, isHover: boolean) {
    this.windowInfo.message = isHover
      ? LanguageManager.instance.getText(
          `chat-tab-list-window.message-list.${messageType}`
        )
      : "";
  }
}
